import type { ReceiptTemplate } from '../schema';

export const zomatoTemplate: ReceiptTemplate = {
  id: 'zomato',
  name: 'Zomato Order Receipt',
  brand: 'Zomato',
  description: 'Zomato food delivery receipt template',
  settings: {
    width: 280,
    font: 'Arial',
    fontSize: 12,
    paperStyle: 'plain',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '₹',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'zomato-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/zomato.png',
        logoData: '',
        logoWidth: 120,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 24,
        addressLines: [],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'zomato-title',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'ORDER INVOICE',
        fontSize: 16,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'zomato-order-info',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'left',
        labelPosition: 40,
        lines: [
          { id: 'zomato-order', label: 'Order ID', value: 'ZMT847291847', isBold: false, isLarge: false },
          { id: 'zomato-date', label: 'Date', value: '04 Jan 2026', isBold: false, isLarge: false },
          { id: 'zomato-time', label: 'Time', value: '8:15 PM', isBold: false, isLarge: false },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'zomato-restaurant',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'FROM: Paradise Biryani\nBanjara Hills, Hyderabad',
        fontSize: 11,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'zomato-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'zomato-item-1', name: 'Special Chicken Biryani', quantity: '1', price: '399.00'},
          { id: 'zomato-item-2', name: 'Mutton Seekh Kebab', quantity: '1', price: '349.00'},
          { id: 'zomato-item-3', name: 'Phirni', quantity: '2', price: '158.00'},
          { id: 'zomato-item-4', name: 'Cold Drink 750ml', quantity: '1', price: '60.00'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'zomato-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 40,
        lines: [
          { id: 'zomato-subtotal', label: 'Item Total', value: '966.00', isBold: false, isLarge: false },
          { id: 'zomato-delivery', label: 'Delivery Fee', value: '35.00', isBold: false, isLarge: false },
          { id: 'zomato-packaging', label: 'Packaging', value: '25.00', isBold: false, isLarge: false },
          { id: 'zomato-gst', label: 'GST (5%)', value: '51.30', isBold: false, isLarge: false },
          { id: 'zomato-pro', label: 'Zomato Pro Discount', value: '-150.00', isBold: false, isLarge: false },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'zomato-total',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 40,
        lines: [
          { id: 'zomato-grand', label: 'TOTAL PAID', value: '927.30', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 25,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'zomato-payment',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'PAID VIA: UPI (GPay)\nTransaction ID: ZMT847291847291',
        fontSize: 10,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'zomato-delivery-info',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'DELIVERED TO:\n456 Jubilee Hills\nHyderabad - 500033\n\nDelivery Partner: Rahul M.',
        fontSize: 10,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'zomato-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Better food for more people\nFor support: help@zomato.com',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};
